export default {
    title: 'Micro-trend',
    action: 'Pin micro-trend to a macro-trend | Pin micro-trends to a macro-trend',
    subtitle: 'Pin the micro-trend to any macro-trend you want. | Pin the micro-trends to any macro-trend you want.',
    count: 'and one additional trend | and {count} additional trends',
    submit: 'Done',
    success: {
        pin: {
            single: 'The micro-trend <strong>{title}</strong> was successfully pinned to the following macro-trends:',
            bulk: 'The selected trends were successfully pinned to the following macro-trends:'
        },
        unpin: 'Micro-trend pin removed successfully'
    }
}
